import { render, staticRenderFns } from "./UserWallet.vue?vue&type=template&id=b145563e&scoped=true&"
import script from "./UserWallet.vue?vue&type=script&lang=js&"
export * from "./UserWallet.vue?vue&type=script&lang=js&"
import style0 from "./UserWallet.vue?vue&type=style&index=0&id=b145563e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b145563e",
  null
  
)

export default component.exports